export const currentFiltersConstants = {
    SET_FILTER: 'CURRENT_FILTERS_SET_FILTER',
    RESET: 'CURRENT_FILTERS_RESET'
}